import config from 'react-global-configuration';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '@uncinc/react-drupal-core';

import { apiRequest } from '../api';

export const LANGUAGE_SET = 'LANGUAGE_SET';
export function setLanguage(language) {
  return {
    type: LANGUAGE_SET,
    language,
  };
}

export const PREV_ORDER_NUMBER_SET = 'PREV_ORDER_NUMBER_SET';
export function setPrevOrderNumber(orderNumber) {
  return {
    type: PREV_ORDER_NUMBER_SET,
    orderNumber,
  };
}

export const PREV_ORDER_INFO_SET = 'PREV_ORDER_INFO_SET';
export function setPrevOrderInfo({ isElearning, isFreeProduct, productType }) {
  return {
    type: PREV_ORDER_INFO_SET,
    isElearning,
    isFreeProduct,
    productType,
  };
}

export const ROOT_CLASSES_ADD = 'ROOT_CLASSES_ADD';
export function addRootClasses(classes) {
  return {
    type: ROOT_CLASSES_ADD,
    classes,
  };
}

export const ROOT_CLASSES_REMOVE = 'ROOT_CLASSES_REMOVE';
export function removeRootClasses(classes) {
  return {
    type: ROOT_CLASSES_REMOVE,
    classes,
  };
}

export const ENABLE_MAINTENANCE_MODE = 'ENABLE_MAINTENANCE_MODE';
export function enableMaintenanceMode() {
  return {
    type: ENABLE_MAINTENANCE_MODE,
  };
}

export const DISABLE_MAINTENANCE_MODE = 'DISABLE_MAINTENANCE_MODE';
export function disableMaintenanceMode() {
  return {
    type: DISABLE_MAINTENANCE_MODE,
  };
}

export const SET_CHECKBOX = 'SET_CHECKBOX';
export function setCheckbox(id, checked) {
  return {
    type: SET_CHECKBOX,
    id,
    checked,
  };
}

export const VOCABULARY_LOADED = 'VOCABULARY_LOADED';
export function vocabularyLoaded(data) {
  return {
    type: VOCABULARY_LOADED,
    data,
  };
}

export const TRACK_EVENT = 'TRACK_EVENT';

export const SHOW_MOBILE_MENU = 'SHOW_MOBILE_MENU';
export function showMobileMenu() {
  return (dispatch) => {
    dispatch(addRootClasses('show-nav'));
    dispatch({ type: SHOW_MOBILE_MENU });
  };
}

export const HIDE_MOBILE_MENU = 'HIDE_MOBILE_MENU';
export function hideMobileMenu() {
  return (dispatch) => {
    dispatch(removeRootClasses('show-nav'));
    dispatch({ type: HIDE_MOBILE_MENU });
  };
}

export const SET_DEVICE_SIZE = 'SET_DEVICE_SIZE';
export function setDeviceSize(deviceSize = null) {
  return {
    type: SET_DEVICE_SIZE,
    deviceSize,
  };
}

export const CLEAR_PAGE_INFORMATION = 'CLEAR_PAGE_INFORMATION';
export const clearPageInformation = () => {
  return {
    type: CLEAR_PAGE_INFORMATION,
  };
};

export const SET_PAGEVIEW_SENT = 'SET_PAGEVIEW_SENT';
export const setPageViewSent = (value) => {
  return {
    type: SET_PAGEVIEW_SENT,
    value,
  };
};

export const SET_PAGE_INFORMATION = 'SET_PAGE_INFORMATION';

// Sets the page information used for the GTM virtual pageview. `metadata`
// holds the content dimensions (subjects, workfields, theme,
// customerJourneyPhase) and is forwarded to the dataLayer as-is.
// NB: no JSDoc @return here on purpose — annotating it as `object` widens the
// inferred type and breaks `dispatch()` at the TypeScript call sites.
export const setPageInformation = (title, metadata = {}) => {
  return {
    type: SET_PAGE_INFORMATION,
    title,
    metadata,
  };
};

export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';
export function setSearchParams(searchParams = '') {
  return {
    type: SET_SEARCH_PARAMS,
    searchParams,
  };
}

/**
 * Track an event through redux-beacon
 * @param {*} category a category.
 * @param {*} action an action performed by the user.
 * @param {*} label A label associated to give context to the category.
 * @param {number} value A value ( if applicable. )
 * @returns {Array} action.
 */
export const trackEvent = (category, action, label, value) => {
  return {
    type: TRACK_EVENT,
    category: category,
    action: action,
    label: label,
    value: value,
  };
};

export const COOKIE_CONSENT_GRANTED = 'COOKIE_CONSENT_GRANTED';

/**
 * Tell redux-beacon and GTM to load additional tags after consent.
 * @returns {Array} action.
 */
export const cookieConsentGranted = () => {
  return {
    type: COOKIE_CONSENT_GRANTED,
  };
};

export const getVocabulary = (vocabulary) => {
  return apiRequest('GET', `entity/view/vocabulary_terms/${vocabulary}/results`, null, vocabularyLoaded);
};

export const SET_CALCULATOR_LOCATIONS_COUNT = 'SET_CALCULATOR_LOCATIONS_COUNT';
export function setCaluclatorLocationsCount(locationsCount = null) {
  return {
    type: SET_CALCULATOR_LOCATIONS_COUNT,
    locationsCount,
  };
}

export const SET_NEWSLETTER_CONTACT_PROPERTY_OPTIONS = 'SET_NEWSLETTER_CONTACT_PROPERTY_OPTIONS';
export const setNewsletterContactPropertyOptions = (data) => {
  return {
    type: SET_NEWSLETTER_CONTACT_PROPERTY_OPTIONS,
    data,
  };
};

export const SET_NEWSLETTER_CONTACT = 'SET_NEWSLETTER_CONTACT';
export const setNewsletterContact = (data) => {
  return {
    type: SET_NEWSLETTER_CONTACT,
    data,
  };
};

export const getNewsletterContactPropertyOptions = (values) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('newsletter', 'property_options', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    let url = `${PATH}/api/email_contact_property_options?_format=json`;

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200 && response.status !== 201) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((response) => {
        dispatch(setNewsletterContactPropertyOptions(response));

        dispatch(setOperationStatus('newsletter', 'property_options', UI_OPERATION_STATUS_SUCCESS));
      })
      .catch(() => {
        dispatch(setOperationStatus('newsletter', 'property_options', UI_OPERATION_STATUS_ERROR));
      });
  };
};

export const createOrUpdateNewsletterContactSubscription = (values) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('newsletter', 'update', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
      .then((csrfResponse) => csrfResponse.text())
      .then((csrfResponse) => {
        const csrfToken = csrfResponse;
        let url = `${PATH}/api/email_subscription?_format=json`;

        fetch(url, {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify(values),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.error) {
              return dispatch(setOperationStatus('newsletter', 'update', UI_OPERATION_STATUS_ERROR, response.error));
            }

            dispatch(setOperationStatus('newsletter', 'update', UI_OPERATION_STATUS_SUCCESS));
          })
          .catch(() => {
            dispatch(setOperationStatus('newsletter', 'update', UI_OPERATION_STATUS_ERROR));
          });
      })
      .catch(() => {
        dispatch(setOperationStatus('newsletter', 'update', UI_OPERATION_STATUS_ERROR));
      });
  };
};

export const getNewsletterContact = (email) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('newsletter', 'contact', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
      .then((csrfResponse) => csrfResponse.text())
      .then((csrfResponse) => {
        const csrfToken = csrfResponse;
        let url = `${PATH}/api/email_contact?_format=json&email=` + encodeURIComponent(email);

        fetch(url, {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.error) {
              dispatch(setNewsletterContact(null));
              return dispatch(setOperationStatus('newsletter', 'contact', UI_OPERATION_STATUS_ERROR, response.error));
            }


            dispatch(setNewsletterContact(response));
            dispatch(setOperationStatus('newsletter', 'contact', UI_OPERATION_STATUS_SUCCESS));
          })
          .catch(() => {
            dispatch(setOperationStatus('newsletter', 'contact', UI_OPERATION_STATUS_ERROR));
          });
      })
      .catch(() => {
        dispatch(setOperationStatus('newsletter', 'contact', UI_OPERATION_STATUS_ERROR));
      });
  };
};
